export const MAIN_CLASS_NAME = 'project-source-table';
export const PAGINATION_ROW_CLASS_NAME = `${MAIN_CLASS_NAME}__pagination-row`;
